<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name 宛先種別
      span.validation-label 必須
    .register-value
      label.register-radio-label()
        input#all-family-type.register-radio-form(v-model="_value" name="target-type" type="radio" value="all" v-validate="{ required: true }" data-vv-as="宛先種別")
        span.register-radio-text 家族全員
      label.register-radio-label(v-if="1 <= _planType")
        input#group-type.register-radio-form(v-model="_value" name="target-type" type="radio" value="group")
        span.register-radio-text グループ
      div(v-show="_planType < 1")
        label#disable-group-type.register-radio-label
          span.register-radio-text.disable グループ
        b-popover(target="disable-group-type" triggers="hover" placement="top")
          template(v-slot:title) グループ
          span 作成した宛先グループ、利用者グループ、施設関係者グループ宛にメッセージを送ることができます。
          br
          span ※ ライトプラン以上で使用可能
      
    .error-messages(v-if="errors.has('target-type')")
      div(v-for="error in errors.collect('target-type')")
        label.error-message {{ error }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";
import { userStore } from "@/store/store";

import { PlanType } from "@/commons/services/Plans";

@Component
export default class InputTargetTypeForFamily extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true })
  value!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): string {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: string) {
    this.$emit("input", newValue);
    return;
  }

  get _planType(): PlanType {
    return userStore.facility.planType;
  }
}
</script>
